"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowPreferences = void 0;
const consts_1 = require("../consts");
const types_1 = require("../types");
const buildWorkflowPreferences = (inputPreferences, defaultPreferences = consts_1.DEFAULT_WORKFLOW_PREFERENCES) => {
    var _a;
    if (!inputPreferences) {
        return defaultPreferences;
    }
    const defaultChannelPreference = Object.assign({}, (((_a = inputPreferences === null || inputPreferences === void 0 ? void 0 : inputPreferences.all) === null || _a === void 0 ? void 0 : _a.enabled) !== undefined ? { enabled: inputPreferences.all.enabled } : {}));
    return Object.assign(Object.assign({}, defaultPreferences), { all: Object.assign(Object.assign({}, defaultPreferences.all), inputPreferences.all), channels: Object.assign(Object.assign({}, defaultPreferences.channels), Object.values(types_1.ChannelTypeEnum).reduce((output, channel) => {
            var _a;
            return (Object.assign(Object.assign({}, output), { [channel]: Object.assign(Object.assign(Object.assign({}, defaultPreferences.channels[channel]), defaultChannelPreference), (_a = inputPreferences === null || inputPreferences === void 0 ? void 0 : inputPreferences.channels) === null || _a === void 0 ? void 0 : _a[channel]) }));
        }, {})) });
};
exports.buildWorkflowPreferences = buildWorkflowPreferences;
